import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.button`
  background: ${colors.success};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${colors.successHover};
  }

  &:disabled {
    background: ${colors.successDisabled};
  }
`;
